import styles from "./Roadmap.module.css";
import RoadmapSectionSkeleton from "./RoadmapSectionSkeleton";

// React
import React, { useState, useEffect } from "react";
import { DragDropContext } from "react-beautiful-dnd";

// components
import RoadmapSection from "./RoadmapSection";
import Loader from "components/Loader";

// Tools
import Services from "tools/Services";
import { Status } from "tools/Enums";

export default function Roadmap() {
	const [features, setFeatures] = useState([]);
	// const [filteredFeatures, setFilteredFeatures] = useState([]);
	const [loading, setLoading] = useState(true);

	useEffect(() => {
		loadRoadmapFeatures();
	}, []);

	const loadRoadmapFeatures = async () => {
		// GET
		let res = await Services.get("/Feature/getRoadmap"); //endpoint

		// ERROR
		if (res.status !== 200) {
			console.error(res);
			return;
		}

		// SUCCESS
		setFeatures([
			res.data.filter((feature) => feature.status === Status.Planned),
			res.data.filter((feature) => feature.status === Status.InProgress),
			res.data.filter((feature) => feature.status === Status.Live),
			// [],
		]);
		setLoading(false);
	};

	const reorder = (list, startIndex, endIndex) => {
		const result = Array.from(list);
		const [removed] = result.splice(startIndex, 1);
		result.splice(endIndex, 0, removed);
		return result;
	};

	const move = (source, destination, droppableSource, droppableDestination) => {
		const sourceClone = Array.from(source);
		const destClone = Array.from(destination);
		const [removed] = sourceClone.splice(droppableSource.index, 1);
		destClone.splice(droppableDestination.index, 0, removed);
		const result = {};
		result[droppableSource.droppableId] = sourceClone;

		// update status when drop in other column
		result[droppableDestination.droppableId] = destClone.map((r) => {
			if (r.status !== +droppableDestination.droppableId + 2) {
				const updatedFeature = { ...r, status: +droppableDestination.droppableId + 2 };
				updateFeature(updatedFeature);
				return updatedFeature;
			}
			return r;
		});
		return result;
	};

	const onDragEnd = (result) => {
		// if (role !== Role.Admin) {
		// 	return;
		// }
		const { source, destination } = result;

		// dropped outside the list
		if (!destination) {
			return;
		}
		const sInd = +source.droppableId;
		const dInd = +destination.droppableId;

		if (sInd === dInd) {
			const items = reorder(features[sInd], source.index, destination.index);
			const newState = [...features];
			newState[sInd] = items;
			setFeatures(newState);
		} else {
			const result = move(features[sInd], features[dInd], source, destination);
			const newState = [...features];
			newState[sInd] = result[sInd];
			newState[dInd] = result[dInd];
			setFeatures(newState);
		}
	};

	const updateFeature = async (updatedFeature) => {
		// PUT
		let res = await Services.put("/Feature", updatedFeature);

		// ERROR
		if (res.status !== 200) {
			console.error(res);
			return;
		}

		// SUCCESS
	};
	return (
		<>
			{loading && (
				<div className={styles.container}>
					<RoadmapSectionSkeleton status={2} />
					<RoadmapSectionSkeleton status={3} />
					<RoadmapSectionSkeleton status={4} />
				</div>
			)}
			{!loading && (
				<div className={styles.container}>
					<DragDropContext onDragEnd={onDragEnd}>
						<RoadmapSection features={features[0]} status={0} />
						<RoadmapSection features={features[1]} status={1} />
						<RoadmapSection features={features[2]} status={2} />
					</DragDropContext>
				</div>
			)}
		</>
	);
}
